import { Box, Skeleton } from "@chakra-ui/react";
import { useAddress } from "../hooks/address.hooks";

function Address({ id }: { id: number | string | null | undefined }) {
  const { data: address, isLoading } = useAddress(id);

  return (
    <Skeleton isLoaded={!isLoading}>
      {address ? (
        <Box>
          {address?.streetNumber} {address?.streetName}
          {", "}
          {address?.city} {address?.postalCode}
          {", "}
          {address?.country}
        </Box>
      ) : (
        <>---</>
      )}
    </Skeleton>
  );
}

export default Address;
